import { render, staticRenderFns } from "./BaseTodoItem.vue?vue&type=template&id=7797fcfc&scoped=true"
import script from "./BaseTodoItem.vue?vue&type=script&lang=js"
export * from "./BaseTodoItem.vue?vue&type=script&lang=js"
import style0 from "./BaseTodoItem.vue?vue&type=style&index=0&id=7797fcfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7797fcfc",
  null
  
)

export default component.exports